import { TOGGLE_DISTRIBUTION_DETAILS_DRAWER, TOGGLE_DISTRIBUTION_DRAWER } from "@/redux/types";

export const toggleDistributionDrawer = (open) => ({
    payload: { open },
    type: TOGGLE_DISTRIBUTION_DRAWER,
});

export const toggleDistributionDetailsDrawer = (open) => ({
    payload: { open },
    type: TOGGLE_DISTRIBUTION_DETAILS_DRAWER,
});
